import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
// import InputAdornment from "@material-ui/core/InputAdornment";
import DialogContentText from "@material-ui/core/DialogContentText";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

export default class NotificationsDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.present.setNotifications}
        </DialogTitle>
        <form>
          <DialogContent style={{ width: 400, maxWidth: "97%", paddingTop: 0 }}>
            <DialogContentText>
              <Typography variant="caption">
                {languages.present.setNotificationsDescription}
              </Typography>
              <Typography style={{ marginTop: 20 }}>
                {languages.present.timeBeforeNotification}
              </Typography>
            </DialogContentText>
            <div style={{ display: "flex" }}>
              <FormControl
                aria-describedby="weight-helper-text"
                style={{ marginRight: 5 }}
              >
                <InputLabel htmlFor="match-duration">
                  {languages.present.hours}
                </InputLabel>
                <Select
                  value={this.props.hours}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "hours",
                    id: "notification-hours",
                  }}
                >
                  {[...Array(25).keys()].map((n) => (
                    <MenuItem key={n} value={n}>
                      {n}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl aria-describedby="weight-helper-text">
                <InputLabel htmlFor="match-duration">
                  {languages.schedule.minutes}
                </InputLabel>
                <Select
                  value={this.props.minutes}
                  onChange={this.props.handleChange}
                  inputProps={{
                    name: "minutes",
                    id: "notification-minutes",
                  }}
                  disabled={this.props.hours === 24}
                >
                  {[...Array(60).keys()].map((n) => (
                    <MenuItem key={n} value={n}>
                      {n}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.cancel}
            </Button>
            <div style={{ position: "relative" }}>
              <Button
                onClick={this.props.handleSubmit}
                variant="contained"
                color="primary"
                type="submit"
              >
                {languages.general.save}
              </Button>
            </div>
          </DialogActions>
        </form>
      </Dialog>
    );
  }
}
